import { render, staticRenderFns } from "./VSummaryFloat.vue?vue&type=template&id=67e6e2c2"
import script from "./VSummaryFloat.vue?vue&type=script&lang=js"
export * from "./VSummaryFloat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports